import React, { useEffect, useState } from "react";
import { Rating } from "react-simple-star-rating";
import "./Product_Inner_Description.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import Black_Btn from "../../../components/common_components/common_btn/Black_Btn/Black_Btn";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import White_Btn from "../../../components/common_components/common_btn/white_btn/White_Btn";
import IncrementDecrementBtn from "../../../components/common_components/common_btn/Increment_Decrement_Btn/IncrementDecrementBtn";
import Blue_Btn from "../../../components/common_components/common_btn/Blue_Btn/Blue_Btn";
import Dark_Blue_Btn from "../../../components/common_components/common_btn/dark_blue_btn/Dark_Blue_Btn";
import Customization_Offcanvas from "./customization_offcanvas/Customization_Offcanvas";
import Added_To_Cart_Modal from "../../common_components/common_modal/added_to_cart_modal/Added_To_Cart_Modal";
import { useDispatch, useSelector } from "react-redux";
import { variant_type } from "../../../utils/common";
import { getAllCart, postCart } from "../../../features/cart/cartSlice";
import { AllSoftType } from "../../../features/master/masterSlice";
import { useNavigate } from "react-router-dom";
import Cancel_Order_btn from "../../common_components/common_btn/cancel_Order_btn/Cancel_Order_btn";

const Product_Inner_Description = ({ product, avgreview }) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    setValue,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const [quantity, setQuantity] = useState(0);
  const dispatch = useDispatch();
  const soft_type = useSelector((state) => state.master.all_soft_type);
  useEffect(() => {
    dispatch(AllSoftType());
  }, [dispatch]);

  const taxPercent = product?.tax_percentage
    ? Number(product?.tax_percentage)
    : 0;
  const basePrice = product?.Product_Variants
    ? Number(product?.Product_Variants[0]?.price || 0)
    : 0;
  const basePricemrp = product?.Product_Variants
    ? Number(product?.Product_Variants[0]?.mrp || 0)
    : 0;
  const taxAmount = (basePrice * taxPercent) / 100;
  const taxAmountmrp = (basePricemrp * taxPercent) / 100;

  const [size, setSize] = useState("Single");

  const material = [
    { id: 1, label: "Extra Soft" },
    { id: 2, label: "Soft" },
    { id: 3, label: "Medium Soft" },
    { id: 4, label: "Medium" },
    { id: 5, label: "Medium Firm" },
  ];
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState();

  const isSignIn = useSelector((state) => state.auth.is_signin);

  const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
  const [selectedDoubleVariantIndex, setSelectedDoubleVariantIndex] = useState(
    0,
  );
  const [selectedTripleVariantIndex, setSelectedTripleVariantIndex] = useState(
    0,
  );

  useEffect(() => {
    setSelectedVariant(product.Product_Variants?.[0]);
  }, [product.Product_Variants?.[0]]);

  useEffect(() => {
    setSelectedVariant(product.Product_Variants?.[0]?.Double_Variants?.[0]);
  }, [product.Product_Variants?.[0]?.Double_Variants?.[0]]);

  useEffect(() => {
    setSelectedVariant(
      product.Product_Variants?.[0]?.Double_Variants?.[0]?.Triple_Variants?.[0],
    );
  }, [
    product.Product_Variants?.[0]?.Double_Variants?.[0]?.Triple_Variants?.[0],
  ]);
  const addToCart = async () => {
    try {
      const data = {
        variant_name: selectedVariant.Diamond?.name,
        product_id: product.id,
        variant_type_id: product.variant_type_id,
        quantity: quantity,
      };
      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant?.id;
      }
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        // handleClick();
        setAddedToCart(true);
        if (res?.payload?.data?.success) {
          await dispatch(getAllCart(isSignIn));
        } else {
        }
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
      setQuantity(0);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const nevigate = useNavigate();

  const addToCartBye = async () => {
    try {
      const data = {
        variant_name: selectedVariant.Diamond?.name,
        product_id: product.id,
        variant_type_id: product.variant_type_id,
        quantity: quantity,
      };
      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant?.id;
      }
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        nevigate("/cart");
        // handleClick();
        // setAddedToCart(true);
        if (res?.payload?.data?.success) {
          await dispatch(getAllCart(isSignIn));
        } else {
        }
        setQuantity(0);
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const variantOptions =
    product?.Product_Variants?.[selectedVariantIndex]?.Double_Variants?.map(
      (doublevariant, index) => ({
        index: index,
        value: doublevariant?.id,
        label: doublevariant?.Size?.name,
        data: doublevariant,
      }),
    ) || [];

  useEffect(() => {
    if (variantOptions.length > 0) {
      const currentValue = getValues("double_variant");

      // if (!currentValue) {
      const first = variantOptions[0];
      setValue("double_variant", first);
      setSelectedDoubleVariantIndex(first.index);
      if (Number(product?.variant_type_id) === variant_type.Double) {
        setSelectedVariant(first.data);
      }
      // }
    }
  }, [selectedVariantIndex, product]);

  const tripleVariantOptions =
    product?.Product_Variants?.[selectedVariantIndex]?.Double_Variants?.[
      selectedDoubleVariantIndex
    ]?.Triple_Variants?.map((triplevariant, index) => ({
      index: index,
      value: triplevariant?.id,
      label: triplevariant?.Diamond?.name,
      data: triplevariant, // optional (if you need full object)
    })) || [];

  useEffect(() => {
    if (tripleVariantOptions.length > 0) {
      const currentValue = getValues("triple_variant");

      // if (!currentValue) {
      const first = tripleVariantOptions[0];

      setValue("triple_variant", first);
      setSelectedTripleVariantIndex(first.index);
      setSelectedVariant(first.data);
      // }
    }
  }, [selectedVariantIndex, selectedDoubleVariantIndex, product]);

  return (
    <section className="Product_Inner_Description">
      <div className="info_div">
        <p className="title_text">{product?.name}</p>
        <div className="price_div">
          <div className="left_div">
            <p className="selling_price">₹ {selectedVariant?.price}</p>
            <p className="mrp">₹ {selectedVariant?.mrp}</p>
          </div>
          <div className="right_div">
            <p className="inner_txt">
              {selectedVariant?.mrp && selectedVariant?.price
                ? `${Math.round(
                    ((selectedVariant.mrp - selectedVariant.price) /
                      selectedVariant.mrp) *
                      100,
                  )}% Off`
                : "0% Off"}{" "}
              <span>(Incl. Of All Taxes)</span>
            </p>
          </div>
        </div>
        <div className="rating_div">
          <FontAwesomeIcon icon={faStar} className="star_icon" />
          {Number(avgreview?.average_rating).toFixed(1)}{" "}
          <span className="inner_text">
            ({avgreview?.total_counts} Reviews)
          </span>
        </div>

        {/* <div className="emi_div">
          <div className="left_side">
            <p className="emi_text">
              ₹1092/mo{" "}
              <span className="subtext">& rest later at 0% EMI on</span>
            </p>
            <p className="upi_text">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icons/upi.png"}
                className="upi_img"
              />
              via
              <img
                src={
                  process.env.PUBLIC_URL + "/assets/images/logo/text_logo.png"
                }
                className="m_text"
              ></img>
              <span className="simpletext">PAYLATER</span>
            </p>
          </div>
          <div className="btn_holder">
            <Black_Btn btnText={"BUY ON EMI"} />
          </div>
        </div> */}

        {product?.Product_Variants?.length > 0 && (
          <div className="size_div">
            <p className="input_label_text">Type</p>

            <div className="btns_holder">
              {product.Product_Variants.map((variant, index) => (
                <button
                  key={index}
                  className={`size_btn ${
                    index === selectedVariantIndex ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedVariantIndex(index);
                    setSelectedDoubleVariantIndex(0);
                    setSelectedTripleVariantIndex(0);
                    if (
                      Number(product?.variant_type_id) === variant_type.Single
                    ) {
                      setSelectedVariant(variant);
                    }
                  }}
                >
                  {variant?.Metal?.name}
                </button>
              ))}
            </div>
          </div>
        )}
        {variantOptions?.length > 0 && (
          <>
            <p className="input_label_text">Size</p>

            <div className="select_div">
              <Controller
                className="select-contoller"
                name={`double_variant`} // name of the field
                control={control}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Select
                    placeholder="Select Size"
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors?.double_variant
                          ? "red"
                          : baseStyles.borderColor,
                      }),
                    }}
                    // {...field}
                    options={variantOptions}
                    onChange={(selectedValue) => {
                      console.log(
                        selectedValue,
                        "electedValue.index electedValue.index",
                      );

                      onChange(selectedValue);
                      setSelectedDoubleVariantIndex(selectedValue.index);

                      if (
                        Number(product?.variant_type_id) === variant_type.Double
                      ) {
                        setSelectedVariant(selectedValue.data);
                      }
                      // setValue("triple_variant", null);
                    }}
                    onBlur={onBlur}
                    value={value}
                    ref={ref}
                  />
                )}
              />
            </div>
          </>
        )}

        {tripleVariantOptions?.length > 0 && (
          <>
            <p className="input_label_text">THICKNESS</p>
            <div className="select_div">
              <Controller
                className="select-contoller"
                name={`triple_variant`} // name of the field
                control={control}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Select
                    placeholder="Select Thickness"
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors?.triple_variant
                          ? "red"
                          : baseStyles.borderColor,
                      }),
                    }}
                    // {...field}
                    options={tripleVariantOptions}
                    onChange={(selectedValue) => {
                      console.log(
                        selectedValue,
                        "electedValue.index electedValue.index",
                      );

                      onChange(selectedValue);
                      setSelectedTripleVariantIndex(selectedValue.index);
                      setSelectedVariant(selectedValue?.data);
                    }}
                    onBlur={onBlur}
                    value={value}
                    ref={ref}
                  />
                )}
              />
            </div>
          </>
        )}

        <p className="input_label_text">
          MATTRESS FEEL <span className="inner_text">(Available In)</span>
        </p>

        <div className="all_type_div">
          {soft_type.map((item, index) => {
            const isActive = product?.soft_type_id === item.id;

            return (
              <div
                key={index}
                className={`item_div ${isActive ? "active" : ""}`}
              >
                <div className="img_holder">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      (isActive
                        ? "/assets/images/product_description/blue.png"
                        : "/assets/images/product_description/white.png")
                    }
                    className="inner_img"
                    alt={item.label}
                  />
                </div>

                <p className="type_text">{item.name}</p>
              </div>
            );
          })}
        </div>

        {/* <div className="customise_div">
          <White_Btn
            btnText={"Customize Your Mattress"}
            onClick={() => {
              setShowOffCanvas(true);
            }}
          />
        </div> */}

        <div className="row justify-content-between align-items-flex-end">
          <div className="col-sm-4 col-7">
            <IncrementDecrementBtn
              selectedVariant={selectedVariant}
              product={product}
              quantity={quantity}
              setQuantity={setQuantity}
            />
          </div>

          {(Number(product.variant_type_id) === variant_type.Single ? (
            Number(selectedVariant?.general_stock) < quantity
          ) : (
            Number(selectedVariant?.stock) < quantity
          )) ? (
            <div className="col-sm-4 col-6">
              <White_Btn btnText={"Out Of Stock"} className="out_of_stock" />
            </div>
          ) : (
            <div className="col-sm-4 col-6">
              <Blue_Btn btnText={"Add To Cart"} onClick={() => addToCart()} />
            </div>
          )}
          {(Number(product.variant_type_id) === variant_type.Single ? (
            Number(selectedVariant?.general_stock) < quantity
          ) : (
            Number(selectedVariant?.stock) < quantity
          )) ? (
            <></>
          ) : (
            <div className="col-sm-4 col-6">
              <Dark_Blue_Btn btnText="Buy Now" onClick={() => addToCartBye()} />
            </div>
          )}
        </div>
      </div>

      <Customization_Offcanvas
        show={showOffCanvas}
        onHide={() => setShowOffCanvas(false)}
        addToCartFunc={() => {
          setShowOffCanvas(false);
          setAddedToCart(true);
        }}
      />

      <Added_To_Cart_Modal
        show={addedToCart}
        onHide={() => setAddedToCart(false)}
      />
    </section>
  );
};

export default Product_Inner_Description;
